import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import KitSection from '../KitSection';
import KitTeam from '../KitTeam';

export default function TeamBlock({
  kits,
  selectedMatch,
  position,
  type,
  className,
  bgImage,
}) {
  const [kitSelected, setKitSelected] = useState(1);

  const handleKitChange = ({ value }) => {
    setKitSelected(value);
  };

  return (
    <S.Container className={className} type={type} bgImage={bgImage}>
      {type !== 'referee' ? (
        <KitSection
          tabMode
          handleKitChange={handleKitChange}
          kitSelected={kitSelected}
          type={type}
          selectedMatch={selectedMatch}
          kits={kits}
        />
      ) : (
        <KitTeam
          kits={kits}
          selectedMatch={selectedMatch}
          position={position}
          type={type}
        />
      )}
    </S.Container>
  );
}

TeamBlock.propTypes = {
  kits: PropTypes.object,
  selectedMatch: PropTypes.object,
  position: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  bgImage: PropTypes.string,
};

TeamBlock.defaultProps = {
  kits: {},
  selectedMatch: {},
  position: '',
  type: '',
  className: '',
  bgImage: '',
};
